var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDangerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.092 2.32337L28.6317 22.6477C28.8637 23.2544 28.9652 23.7477 28.9942 24.2601C29.0522 25.4575 28.6752 26.6213 27.9359 27.5169C27.1965 28.4093 26.1962 28.9361 25.1088 29H3.88441C3.43499 28.9697 2.98556 28.8563 2.56513 28.6807C0.462987 27.7388 -0.551842 25.0887 0.303514 22.7914L10.9157 2.309C11.2782 1.589 11.8291 0.967985 12.5105 0.568873C14.4821 -0.646023 16.9902 0.152201 18.092 2.32337ZM15.7582 15.7174C15.7582 16.4837 15.1928 17.1238 14.4969 17.1238C13.8011 17.1238 13.2212 16.4837 13.2212 15.7174V11.201C13.2212 10.4331 13.8011 9.8121 14.4969 9.8121C15.1928 9.8121 15.7582 10.4331 15.7582 11.201V15.7174ZM14.4969 22.5838C13.8011 22.5838 13.2212 21.9436 13.2212 21.1789C13.2212 20.411 13.8011 19.7724 14.4969 19.7724C15.1928 19.7724 15.7582 20.3967 15.7582 21.1614C15.7582 21.9436 15.1928 22.5838 14.4969 22.5838Z",
    fill: "#F64040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/dangerIcon.54f69eb13ec1c8d4ed1a592595ec0724.svg";
export { ForwardRef as ReactComponent };